import classNames from 'classnames';
import logoImg from 'assets/img/brand/treez-nav.svg';
import routeConfig from 'routes/config';
import useAuth from 'state/auth/hooks/useAuth';
import { Button } from 'components/ui/button';

const AuthNavbar = (): JSX.Element => {
  const pathname = window.location.pathname;
  // Normalize pathname by removing trailing slash to handle /auth/login and /auth/login/
  const normalizedPath = pathname.replace(/\/$/, '');
  const isLoginPage = normalizedPath === '/auth/login';
  const showSignOut = pathname.includes(
    `${routeConfig.STORES.layout}/${routeConfig.STORES.LIST.path}`
  );
  const { toLogout } = useAuth();

  const logout = () => {
    toLogout();
  };

  return (
    <nav
      className={classNames(
        'flex justify-between h-16 py-0 border-b border-gray-blue-10 w-full bg-white',
        isLoginPage ? 'px-0' : 'px-4'
      )}
    >
      <a
        href="https://www.treez.io/payments"
        target="_blank"
        rel="noreferrer"
        className="flex items-center shrink-0"
      >
        <img alt="Treez Payments" src={logoImg} className="h-5" />
      </a>
      {showSignOut && (
        <Button
          onClick={logout}
          variant="ghost"
          iconStart="log-out"
          iconSize={20}
          iconClassName="text-gray-blue-50"
          className="gap-1.5 text-gray-blue-80 hover:bg-gray-blue-3 hover:text-gray-blue-80 my-auto"
        >
          Sign out
        </Button>
      )}
    </nav>
  );
};

export default AuthNavbar;
